"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var AXSBlock_1 = __importDefault(require("../../AXSBlock/AXSBlock"));
var classnames_1 = __importDefault(require("classnames"));
var AXSCard = function (_a) {
    var backgroundColor = _a.backgroundColor, backgroundImage = _a.backgroundImage, borderColor = _a.borderColor, borderRadius = _a.borderRadius, color = _a.color, boxShadow = _a.boxShadow, className = _a.className, style = _a.style, children = _a.children, props = __rest(_a, ["backgroundColor", "backgroundImage", "borderColor", "borderRadius", "color", "boxShadow", "className", "style", "children"]);
    return (React.createElement(AXSBlock_1.default, __assign({}, props, { color: color, backgroundColor: backgroundColor, backgroundImage: backgroundImage, borderColor: borderColor, borderRadius: borderRadius, boxShadow: boxShadow, className: classnames_1.default(['c-axs-card', className]) }), children));
};
AXSCard.defaultProps = {
    backgroundColor: 'axsui.components.card.backgroundColor',
    borderColor: 'axsui.components.card.borderColor',
    borderRadius: 'axsui.components.card.borderRadius',
    boxShadow: 'axsui.components.card.shadow',
    color: 'axsui.components.card.color',
};
exports.default = AXSCard;
//# sourceMappingURL=index.js.map